import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const STATS = [
  { value: 50, suffix: "+", label: "Projekte umgesetzt" },
  { value: 3.2, suffix: "x", label: "Ø Return on Ad Spend", decimals: 1 },
  { value: 98, suffix: "%", label: "Kundenzufriedenheit" },
];

function Counter({ value, suffix, decimals = 0 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const duration = 1600;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setCount(eased * value);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <span ref={ref}>
      {count.toFixed(decimals)}
      {suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section className="bg-ink">
      <div className="mx-auto grid max-w-[1360px] grid-cols-1 gap-y-12 px-5 py-16 sm:grid-cols-3 md:px-10 md:py-24">
        {STATS.map((s, i) => (
          <div key={s.label} data-testid={`stat-${i}`} className="flex flex-col items-start">
            <div className="font-display text-5xl text-white md:text-7xl">
              <span className="text-[#7c86ff]">
                <Counter value={s.value} suffix={s.suffix} decimals={s.decimals || 0} />
              </span>
            </div>
            <p className="mt-3 text-sm text-[#b3ada2] md:text-base">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
